<ng-container *ngIf="formGroup as fg">
  <div *ngIf="controlInfo as c" [formGroup]="fg">
    <label for="simple-input-text-form-{{controlId}}" class="form-label">
      {{c.alias ?? c.name}}
      <span *ngIf="c.required" class="text-red-400">*</span>
      <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
    </label>
    <div class="form-group">
      <mat-date-range-input [rangePicker]="picker_CoveredDate" class="form-group-input">
        <input formControlName="start" matStartDate placeholder="Select Date" id="simple-input-text-form-{{controlId}}">
        <input formControlName="end" matEndDate>
      </mat-date-range-input>
      <div class="form-group-label">
        <button (click)="picker_CoveredDate.open()" type="button" class="outline-none">
          <i class="fal fa-calendar"></i>
        </button>
        <mat-date-range-picker #picker_CoveredDate></mat-date-range-picker>
      </div>
    </div>
    <div *ngIf="getDateRangeInvalid" class="text-red-400">
      <div *ngIf="fg.controls['start'].errors?.['required']" class="text-sm">
        * Start Date is required.
      </div>
      <div *ngIf="fg.controls['end'].errors?.['required']" class="text-sm">
        * End Date is required.
      </div>
    </div>
  </div>
</ng-container>